/**
 * Sort the given values using the identifierFunc to specify the sort value.
 * @param values Array to sort.
 * @param identifierFunc Function to retrieve the sort value from the object. Note: sort value must be string.
 * @param compareFunc optional compare function which sorts the entries. Defaults to descending order.
 * @returns The sorted array.
 */
export function orderByIdentifier(values, identifierFunc, compareFunc) {
    return values.sort((a, b) => compareFunc ? compareFunc(identifierFunc, a, b) : DescendingCompareFunc(identifierFunc, a, b));
}
/**
 * Gets the default compare function given the ViewCriterias order.
 * @param order The order value
 * @returns A compare function matching the order, defaults to descending order.
 */
export function getDefaultCompareFunc(order) {
    return order === 'asc' ? AscendingCompareFunc : DescendingCompareFunc;
}
/**
 * Default compare function which sorts entries in Descending order.
 * @param identifierFunc Function to retrieve the sort value from the object. Note: sort value must be string.
 * @param a The first value to check.
 * @param b The first value to check.
 * @return A number representing the result of the comparison
 */
export const AscendingCompareFunc = function (identifierFunc, a, b) {
    return identifierFunc(a).toString().localeCompare(identifierFunc(b).toString());
};
/**
 * Default compare function which sorts entries in Descending order.
 * @param identifierFunc Function to retrieve the sort value from the object. Note: sort value must be string.
 * @param a The first value to check.
 * @param b The first value to check.
 * @return A number representing the result of the comparison
 */
export const DescendingCompareFunc = function (identifierFunc, a, b) {
    return identifierFunc(b).toString().localeCompare(identifierFunc(a).toString());
};
//# sourceMappingURL=viewUtils.js.map